import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import api from "../../api/api";

export const addValuatorBankDetail = createAsyncThunk(
	"ValuatorBankDetails/add",
	async (data) => {
		try {
			const response = await api.post(`/v1/ValuatorBank`, data, {
				headers: {
					"Content-Type": "application/json",
				},
			});
			toast.success("Bank Details added successfully!");
			return response.data?.data || response.data;
		} catch (error) {
			const res = error.response.data?.data;
			if (res?.Errors && Array.isArray(res.Errors)) {
				res.Errors.forEach((err) => {
					toast.error(err);
				});
			} else {
				toast.error(res?.Message || "Failed to add Bank Details ");
			}
		}
	},
);
const ValuatorBankDetailSlice = createSlice({
	name: "ValuatorBankDetail",
	initialState: {
		data: [],
		selected: null,
		loading: false,
		error: null,
		successMessage: null,
	},
	reducers: {
		clearValuator(state) {
			state.data = null;
		},
	},
	extraReducers: (builder) => {
		builder
			//add
			.addCase(addValuatorBankDetail.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(addValuatorBankDetail.fulfilled, (state, action) => {
				state.loading = false;
				state.successMessage = "Bank Details added successfully";
				state.data.push(action.payload);
			})
			.addCase(addValuatorBankDetail.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload;
			});
	},
});

export const { clearValuator } = ValuatorBankDetailSlice.actions;

export default ValuatorBankDetailSlice.reducer;
